import {
  formattedPropertyModel,
  intlShape,
  locationContainer,
  PlainTextOrHtml,
  utils,
} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';
import {connect} from 'react-redux';

import styles from './CaseHaiRFLinkFormatter.less';
import {DocumentLink} from 'src/js/containers/file/components/DocumentLink';
import {getFilterStringWithReuseFilters} from 'src/js/lib/raw_rendering/base_report_link_formatter_params';
import {
  CellRendererParams,
  CELL_RENDERER_PARAMS,
  CELL_RENDERER_PARAMS_AG,
} from 'src/js/model/cell_renderer_params';

const ROUTE_HAIR_RF_DETAIL = '/haiRFDetail';
const FILTER_RISK_FACTOR_CODE = 'riskFactorCode';

const I18N = defineMessages({
  OPEN_DETAIL: {
    id: 'common.link.openDetail',
    defaultMessage: 'Open detail',
    description: 'title text for detail link',
  },
  NEW: {
    id: 'hai.dashboard.report.haiRF.new',
    defaultMessage: 'NEW',
    description: 'title text for detail link',
  },
  NEW_TITLE: {
    id: 'hai.dashboard.report.haiRF.new.title',
    defaultMessage: 'New risk factor',
    description: 'title text for detail link',
  },
});

class CaseHaiRFLinkFormatter extends React.PureComponent {
  render() {
    const {colDef, data, intl, value, queryParameters} = this.props;
    const rowData = data;
    const formatterParams = new CellRendererParams(
      colDef[CELL_RENDERER_PARAMS_AG] || colDef[CELL_RENDERER_PARAMS] || {}
    );

    const label = formattedPropertyModel.FormattedProperty.formatLabel(
      value,
      intl,
      rowData,
      formatterParams.getI18nParams()
    );

    let filterString = `${FILTER_RISK_FACTOR_CODE}:'${rowData.id}'`;
    if (formatterParams.getReuseFilter()) {
      filterString = getFilterStringWithReuseFilters(
        formatterParams,
        queryParameters,
        filterString
      );
    }
    return (
      <div>
        {rowData.alarm_label === 'NEW' && (
          <span
            className={styles.dlNewRF}
            title={utils.TranslateUtils.translate(I18N.NEW_TITLE, intl)}
          >
            {utils.TranslateUtils.translate(I18N.NEW, intl)}
          </span>
        )}
        <DocumentLink
          documentDetailRoute={ROUTE_HAIR_RF_DETAIL}
          titleText={`${utils.TranslateUtils.translate(
            I18N.OPEN_DETAIL,
            intl
          )} - ${label}`}
          searchParams={{filter: `${filterString}`}}
          suppressPadding
        >
          <PlainTextOrHtml text={label} showHtml />
        </DocumentLink>
      </div>
    );
  }
}

CaseHaiRFLinkFormatter.displayName = 'CaseHaiRFLinkFormatter';

CaseHaiRFLinkFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CaseHaiRFLinkFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(
  connect((state) => ({
    queryParameters:
      state[locationContainer.LOCATION_REDUCER_STATE_ID].parameters,
  }))(CaseHaiRFLinkFormatter)
);
